import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { GtModule } from './app/gt.module';
import { environment } from './environments/environment';
import { syncLegacySupportWidgets } from './legacy-support-widgets';
(function () {
	var widths = [];
	var heights = [];
	var width;
	var height;

	var charts = [ 'assessed-graph', 'app-eachbar'];
	var beforePrint = function () {
		widths = [];
		heights = [];
		charts.forEach(function (value) {
			var svg = document.getElementById(value);
			if (typeof svg != 'undefined' && svg != null) {
				var childDiv = svg.getElementsByTagName('svg')[0];
				width = childDiv.getAttribute('width');
				console.log('width: ', width);
				height = childDiv.getAttribute('height');
				console.log('height: ', height);
				widths.push(width);
				heights.push(height);
				childDiv.removeAttribute('width');
				childDiv.removeAttribute('height');
				childDiv.setAttribute('viewBox', `0 0 ${width} ${height}`);
			}
		});
	};

	var afterPrint = function () {
		charts.forEach(function (value, index) {
			var svg = document.getElementById(value);
			if (typeof svg != 'undefined' && svg != null) {
				var childDiv = svg.getElementsByTagName('svg')[0];

				console.log("TEST WIDTHS ", widths);
				console.log("TEST HEIGHTS ", heights);
				console.log("TEST CHARTS ", charts);
				// heights.push(height);
				childDiv.setAttribute('width', widths[index]);
				childDiv.setAttribute('height', heights[index]);
				childDiv.removeAttribute('viewBox');
			}
		});
	};

	window.onbeforeprint = beforePrint;
	window.onafterprint = afterPrint;
})();

if (environment.production) {
	enableProdMode();
	if (window) {
		window.console.log = function () {};
	}
}

syncLegacySupportWidgets(window.location.pathname);

platformBrowserDynamic()
	.bootstrapModule(GtModule)
	.catch((err) => console.error(err));
